import React from "react";
import "~/css/RubyText.css";

interface RubyTextProps {
  text: string;
}

const RubyText: React.FC<RubyTextProps> = ({ text }) => {
  const parseText = (text: string) => {
    const regex = /(\p{Script=Hani}+)\((\p{Script=Hiragana}+)\)/gu;
    const parts: React.JSX.Element[] = [];
    let lastIndex = 0;
    let match: RegExpExecArray | null;

    while ((match = regex.exec(text)) !== null) {
      const [, base, ruby] = match;
      const start = match.index;
      const end = regex.lastIndex;

      if (start > lastIndex) {
        parts.push(<span key={lastIndex}>{text.slice(lastIndex, start)}</span>);
      }

      parts.push(
        <ruby key={start}>
          {base}
          <rt>{ruby}</rt>
        </ruby>
      );

      lastIndex = end;
    }

    if (lastIndex < text.length) {
      parts.push(<span key={lastIndex}>{text.slice(lastIndex)}</span>);
    }

    return parts;
  };

  return <div className="character-name">{parseText(text)}</div>;
};

export default RubyText;
